import Controller from "./notification.controller";
import template from "./notification.html";

const notification = {
  template,
  controller: Controller,
};

export default notification;



// WEBPACK FOOTER //
// ./src/components/notification/notification.component.js